export function formatDateTime(value?: string | null) {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
}

export function formatDateTimeMinute(value?: string | null) {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

export function formatMs(value?: number | null) {
  if (value === undefined || value === null || value <= 0) return '-';
  if (value >= 1000) {
    return `${(value / 1000).toFixed(value >= 10000 ? 1 : 2)} s`;
  }
  return `${Math.round(value)} ms`;
}

export function formatCount(value?: number | null) {
  if (value === undefined || value === null) return '-';
  return new Intl.NumberFormat('en-US').format(value);
}

export function formatPercent(value: number) {
  if (!Number.isFinite(value)) return '-';
  return `${Math.round(value * 100)}%`;
}

export function shortId(value?: string | null) {
  if (!value) return '-';
  if (value.length <= 18) return value;
  return `${value.slice(0, 8)}...${value.slice(-6)}`;
}

export function statusVariant(
  status?: string
): 'default' | 'secondary' | 'destructive' | 'outline' {
  switch (status) {
    case 'success':
      return 'secondary';
    case 'failed':
    case 'timeout':
    case 'canceled':
    case 'completed_with_errors':
      return 'destructive';
    default:
      return 'outline';
  }
}

export function compactStatusLabel(status?: string) {
  switch (status) {
    case 'completed_with_errors':
      return 'with errors';
    case 'success':
      return 'success';
    case 'failed':
      return 'failed';
    case 'timeout':
      return 'timeout';
    case 'canceled':
      return 'canceled';
    case 'running':
      return 'running';
    default:
      return status || '-';
  }
}

export function qualityVariant(
  value?: string
): 'default' | 'secondary' | 'destructive' | 'outline' {
  switch (value) {
    case 'exact':
    case 'backfilled':
      return 'secondary';
    case 'ambiguous':
    case 'source_retained_out':
      return 'destructive';
    case 'not_collected':
    case 'unmapped':
    case 'not_applicable':
    default:
      return 'outline';
  }
}
